export default {
    CHANGE_CONFIG: 'FINANCIALCHANGECONFIG',
    LOADING: 'FINANCIALLOADING',
    OPEN_DETAILS: 'FINANCIALOPENDETAILS',
    REQUEST_PAYMENT_LIST: 'FINANCIALREQUESTPAYMENTLIST',
    SET_CONFIG: 'FINANCIALSETCONFIG',
    SET_MODAL_OPEN: 'FINANCIALSETMODALOPEN',
    SET_PAYMENT_LIST: 'FINANCIALSETPAYMENTLIST',
    SET_PAYMENT_DETAILS: 'FINANCIALSETPAYMENTDETAILS',
}